var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TimeStampModifiers } from "../../../../data";
import { computed } from "mobx";
import { entities } from "sbtech-sports-data-api-client";
/* istanbul ignore next */
export class TimestampFormatter {
    constructor(masterEvent, dict) {
        this.masterEvent = masterEvent;
        this.dict = dict;
    }
    /* istanbul ignore next */
    get modifierDatePeriodTimes() {
        return this.masterEvent.isLive
            ? TimeStampModifiers.modifierLiveTime
            : TimeStampModifiers.modifierDatePeriod;
    }
    /* istanbul ignore next */
    get modifierTimeScore() {
        return this.masterEvent.isLive
            ? TimeStampModifiers.modifierScore
            : TimeStampModifiers.modifierTime;
    }
    /* istanbul ignore next */
    get textDatePeriodTime() {
        if (this.masterEvent.isLive) {
            if (this.masterEvent.liveStartCountdown > 0) {
                return `${this.dict.StartsIn} ${this.masterEvent.formattedCountdown}`;
            }
            if (this.masterEvent.liveGameState
                && this.masterEvent.liveGameState.gamePart) {
                return `${this.dict[this.masterEvent.liveGameState.gamePart]} ${this.shouldShowTime ?
                    this.masterEvent.liveGameState.formattedTime :
                    ""}`;
            }
            return "";
        }
        return this.masterEvent.eventDate;
    }
    /* istanbul ignore next */
    get textTimeScore() {
        if (this.masterEvent.isLive) {
            if (this.masterEvent.liveGameState) {
                return `${this.masterEvent.score1 || ""}-${this.masterEvent.score2 || ""}`;
            }
            return "";
        }
        return this.masterEvent.eventTime;
    }
    get shouldShowTime() {
        return !this.getInactiveGamesStates()
            .some(status => (!!this.masterEvent.liveGameState &&
            (this.masterEvent.liveGameState.gamePart && this.masterEvent.liveGameState.gamePart === status
                || this.masterEvent.liveGameState.gameTime === null)));
    }
    getInactiveGamesStates() {
        return [entities.GamePart.BreakAfterFirstOvertime,
            entities.GamePart.BreakAfterFirstPeriod,
            entities.GamePart.BreakAfterSecondPeriod,
            entities.GamePart.BreakAfterThirdPeriod,
            entities.GamePart.BreakAfterFirstQuarter,
            entities.GamePart.BreakAfterSecondQuarter,
            entities.GamePart.BreakAfterThirdQuarter,
            entities.GamePart.BreakAfterFourthQuarter,
            entities.GamePart.BreakAfterFirstHalf
        ];
    }
}
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], TimestampFormatter.prototype, "modifierDatePeriodTimes", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], TimestampFormatter.prototype, "modifierTimeScore", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], TimestampFormatter.prototype, "textDatePeriodTime", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], TimestampFormatter.prototype, "textTimeScore", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], TimestampFormatter.prototype, "shouldShowTime", null);
//# sourceMappingURL=TimeStampFormatter.js.map